<template>
  <b-card>
    <b-row align-v="start">
      <b-col>
        <span class="h5 mt-0 mb-0" v-if="item.state === 0">
          <i class="fa fa-circle mr-2" style="color: grey"></i>
          <b>{{$t('views.excmagreements.list.filters.state')}}</b>
        </span>
        <span v-else-if="item.finished === 1"
              class="h5 mt-0 mb-0">
          <i class="fa fa-circle fa-lg mr-2"
             style="color: #28a745">
          </i>
          <b>{{ $t('views.excmrelation.list.finished') }}</b>
        </span>
        <span v-else-if="item.finished === 0 && item.started === 1"
              class="h5 mt-0 mb-0">
          <i class="fa fa-circle fa-lg mr-2"
             style="color: #ffc107">
          </i>
            <b>{{ $t('views.excmtask.show.inProgress') }}</b>
        </span>
        <span v-else-if="item.finished === 0 && item.started === 0"
              class="h5 mt-0 mb-0">
          <i class="fa fa-circle fa-lg mr-2"
             style="color: #dc3545">
          </i>
            <b>{{ $t('views.excmtask.show.dailyPlanItemStatuses.notOver') }}</b>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <p v-if="item.idTaskType" >{{$t('routes.EXCMTaskTypeShow')}}: <span class="h6"> {{ item.idTaskType.title }}</span></p>
        <p v-if="item.idCase.caseType" >{{$t('routes.EXCMCaseTypeShow')}}: <span class="h6">{{ item.idCase.caseType.title }}</span></p>
        <p>{{$t('views.exsborder.list.idCase')}}: <span class="h6"><span v-if="item.idCase.number">{{ item.idCase.number }}</span><span v-else>{{ getIdFromLink(item.idCase['@id']) }}</span></span></p>
        <hr>
      </b-col>
    </b-row>
    <b-row align-h="between">
      <b-col>
        <p class="mb-0">
          {{$t('views.excmcase.show.created')}} - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
        </p>
        <p v-if="item.deadlineDate">
          {{ $t('views.excmtask.show.deadlineDate') }} - {{$moment(item.deadlineDate).format('YYYY-MM-DD HH:mm')}}
        </p>
        <p v-if="item.finished === 1">
          {{$t('views.excmcase.show.finished')}} {{item.finishDate ? $moment(item.finishDate).format('YYYY-MM-DD HH:mm') : ''}}
          <span v-if="item.idFinishByUserData">- {{item.idFinishByUserData.name}} {{item.idFinishByUserData.surname}}</span>
        </p>
        <button v-if="ableToStartTask && item.canUpdate" type="button" class="btn btn-sm " @click="startTask(item['@id'])">{{ $t('buttons.start') }}</button>
      </b-col>
      <b-col align-self="end">
        <div v-if="item.finished === 0">
          <div v-if="item.deadlineDate && getProgress(item) < 100">
            <small>
                {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
            </small>
            <small class="float-right">
              {{ $moment(item.deadlineDate).format('YYYY-MM-DD HH:mm')}}
            </small>
            <Progress
              :type="(getProgress(item) > 100 && item.finished !== 1) ? 'danger' : 'primary'"
              :value="getProgress(item) > 100 ? 100 : getProgress(item)">
            </Progress>
          </div>
          <div :class="getProgress(item) < 100 ? 'text-center' : 'float-right'">
            <h6>
              <b-badge :variant="getProgress(item) > 100 ? 'danger' : null">
                {{ getProgress(item) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item) + ' %' }}
              </b-badge>
            </h6>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <TaskExistingCustomFields :item="item"/>
      </b-col>
      <b-col cols="12">
        <div>
          <button type="button" class="btn btn-success btn-sm" v-b-tooltip.hover :title="$t('buttons.editTaskParams')" @click="editTaskParams(item)" v-if="ableToEditTask">
            <i class="fa fa-pencil"></i>
          </button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Progress from '../../../../UIComponents/Progress'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import { mapActions } from 'vuex'
import TaskExistingCustomFields from '@/components/Dashboard/Views/excmtask/components/TaskExistingCustomFields'

export default {
  name: 'AdditionalItem',
  computed: {
    getUserId () {
      return getUserRoles().id_userdata
    },
    hasOwnerRoles () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER')
    },
    ableToStartTask () {
      return (this.item.lastPoolTask && this.item.lastPoolTask.operationTransferUserData &&
        (getId(this.item.lastPoolTask.operationTransferUserData['@id']) === this.getUserId) &&
        this.item.started === 0 && this.item.finished === 0)
    },
    ableToEditTask () {
      if (this.hasOwnerRoles) {
        return true
      }
      return checkPermission('tasks', 'EXCMTaskUpdate') && this.item.canUpdate && this.item.finished === 0 &&
        (this.item.lastPoolTask && this.item.lastPoolTask.operationTransferUserData && (getId(this.item.lastPoolTask.operationTransferUserData['@id']) === this.getUserId))
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    TaskExistingCustomFields,
    Progress
    // TaskDetails
  },
  methods: {
    ...mapActions({
      retrieve: 'excmtask/show/retrieve'
    }),
    editTaskParams () {
      this.$store.state.modals.updateTaskParams.show = 1
      this.$store.state.modals.updateTaskParams.path = this.item['@id']
    },
    getProgress (task) {
      if (!task.deadlineDate) {
        return 100
      } else {
        let created = this.$moment(task.createdAt)
        let deadline = this.$moment(task.deadlineDate)
        return this.calculateProgress(created, deadline)
      }
    },
    calculateProgress (created, deadline) {
      let denominator, nominator
      denominator = deadline.diff(created)
      nominator = this.$moment().diff(created)
      return Math.round((nominator / denominator) * 100)
    },
    async startTask (iri) {
      let id = getId(iri)
      await new ApiService(`e_x_c_m_tasks/${id}/start`).put({})
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    getIdFromLink (link) {
      return parseInt(getId(link))
    }
  }
}
</script>
